import { render, staticRenderFns } from "./largeInspection.vue?vue&type=template&id=417d900c&scoped=true"
import script from "./largeInspection.vue?vue&type=script&lang=js"
export * from "./largeInspection.vue?vue&type=script&lang=js"
import style0 from "./largeInspection.vue?vue&type=style&index=0&id=417d900c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417d900c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('417d900c')) {
      api.createRecord('417d900c', component.options)
    } else {
      api.reload('417d900c', component.options)
    }
    module.hot.accept("./largeInspection.vue?vue&type=template&id=417d900c&scoped=true", function () {
      api.rerender('417d900c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/largeInspection.vue"
export default component.exports